import { render, staticRenderFns } from "./Page-Financer.vue?vue&type=template&id=2472b7e8&"
import script from "./Page-Financer.vue?vue&type=script&lang=js&"
export * from "./Page-Financer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports